import Stripe from "@/modules/stripe";
import { STATES_SELECT_LIST } from "@/constants/select";

export const required = value => {
  const trimmed = typeof value === "string" ? value.trim() : value;
  return value && trimmed ? undefined : "Required";
};

export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)
    ? "Invalid email address"
    : undefined;

export const phone = value =>
  value && !/^\+(?:[0-9] ?){6,14}[0-9]$/.test(value)
    ? "Invalid Phone Number"
    : undefined;

export const url = value =>
  value &&
  !/^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/.test(
    value
  )
    ? "Invalid URL"
    : undefined;

export const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;

export const minLength = min => value =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined;

export const length = valToBe => val =>
  val && val.length !== valToBe ? `Must be ${valToBe} characters` : undefined;

export const zip = value =>
  value && /^\d{5}(-[\dA-Z]{4})?$/.test(value) ? "" : "Invalid zip";

export const state = (val, country = "US") => {
  if (country !== "US" && val && val.length < 2) {
    return "Must be more than 2 characters";
  }
  if (country !== "US" && val && val.length > 40) {
    return "Must be less than 40 characters";
  }
  return val &&
    country === "US" &&
    STATES_SELECT_LIST.findIndex(
      state => state.key.toLowerCase() === val.toLowerCase()
    ) === -1
    ? `"${val}" is not US state`
    : undefined;
};

export const year = value =>
  value && !/^[1-9][1-9]$/.test(value)
    ? "Must be 2 digits value (YY format)"
    : undefined;

export const creditCard = value =>
  value &&
  !/^\d{4}-\d{4}-\d{4}-\d{4}$/.test(value) &&
  value &&
  !/^\d{16}|\d{15}|\d{14}$/.test(value)
    ? "Invalid format"
    : undefined;

export const samePasswords = (password, repeatPassword) =>
  password !== repeatPassword ? "Passwords do not match" : undefined;

export const maxLengthSplit = max => (firstValue, secondValue) =>
  firstValue && secondValue && firstValue.length + secondValue.length > max
    ? `This two inputs together must be ${max} characters or less`
    : undefined;

export const requiredTags = values => (values.length ? undefined : "Required");

export const cardNumber = value =>
  value && !!Stripe.card.validateCardNumber(value) ? undefined : "Invalid card";

export const cardExpiry = value =>
  value && !!Stripe.card.validateExpiry(value) ? undefined : "Invalid expiry";

export const cardCvc = value =>
  value && !!Stripe.card.validateCVC(value) ? undefined : "Invalid CVC";

/**
 * Allows to validate field by given value and
 * validate functions in array or standalone
 * @param value
 * @param validate
 * @param allValues
 * @returns {Array}
 */
export const validate = (value, validate, allValues) => {
  const errors = [];
  if (validate) {
    if (Array.isArray(validate)) {
      validate.forEach(f => {
        const err = f(value, allValues);
        if (err) {
          errors.push(err);
        }
      });
    } else {
      const err = validate(value, allValues);

      if (err) {
        errors.push(err);
      }
    }
  }

  return errors;
};
